import React from 'react';
import { LanguageProvider } from '../../contexts/LanguageContext';
import { UOMProvider } from '../../contexts/UOMContext';
import { MessageProvider, MessageContainer } from '../../components/Messages';
import OperatorPage from './OperatorPage';

// /operator lives outside MainApp: give it the providers its shared modals
// (Fin de Turno → ShiftHandoffModal, UOMSelect) need.
const OperatorApp = () => (
  <LanguageProvider>
    <UOMProvider>
      <MessageProvider>
        <OperatorPage />
        <MessageContainer />
      </MessageProvider>
    </UOMProvider>
  </LanguageProvider>
);

export default OperatorApp;
